import Axios from '../baseApi'
export default {
  async fetch() {
    return await Axios.get(`api-master-data/v1/unit`);
  },
  async fetchByGroup(group) {
    return await Axios.get(`api-master-data/v1/unit/${group}`);
  }
}
